import { useRouter } from 'next/router';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getToken } from '@/helpers/auth';
import { fetchProduct } from '@/fetchers/products';
import { getLangCountry } from '@/helpers/languages';
import { IProduct } from '@/models';

export function useProduct(
  slug: string,
  options?: UseQueryOptions<IProduct | null>
) {
  const token = getToken();
  const router = useRouter();
  const { lang, country } = getLangCountry(router.query);

  return useQuery<IProduct | null>(
    ['product', slug, lang, country],
    async () => {
      return fetchProduct({
        token,
        slug,
        ...getLangCountry(router.query)
      });
    },
    options
  );
}
